// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colaborador-infos {
  display: flex;
  margin: 0;
  margin-bottom: 40px;
  border-width: 1px 0;
  border-style: solid;
  border-color: #d9d9dc;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
}
.colaborador-infos .btnObtenerPDF {
  color: #7A6BE8;
}
.colaborador-infos .btnObtenerPDF:hover {
  color: #9b91ec;
}
.colaborador-infos .btnObtenerPDF:focus {
  box-shadow: none;
}
.colaborador-infos li {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.colaborador-infos li:nth-child(even) {
  font-weight: bold;
}
.colaborador-infos li:nth-child(even):nth-child(2) {
  font-size: 20px;
}
.colaborador-infos li:nth-child(even) svg {
  fill: #fff;
  left: 2.3px;
  position: relative;
  transform: scale(0.7);
}
.colaborador-infos .more-info {
  position: relative;
  color: #41C8FF;
  font-size: 14px;
}
.colaborador-infos .more-info > button {
  display: flex;
  align-items: center;
}

.item-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  text-align: center;
  width: 30px;
  height: 30px;
  border-radius: 50rem;
  background-color: #7A6BE8;
  border: 1px solid #7A6BE8;
  padding: 4px;
  transition: 300ms;
}
.item-circle:where(:hover, :active) {
  background-color: transparent;
}
.item-circle svg {
  position: relative;
  left: 4px;
}

.item-circle-white {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  text-align: center;
  width: 30px;
  height: 30px;
  border-radius: 50rem;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 4px;
  transition: 300ms;
}
.item-circle-white:where(:hover, :active) {
  background-color: transparent;
}
.item-circle-white svg {
  position: relative;
  left: 4px;
}

.item-circle-down {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  cursor: pointer;
}
.item-circle-down svg {
  fill: #41C8FF !important;
  transform: scale(0.5);
}

.item-menu {
  margin-right: 10px;
}
.item-menu:nth-child(1) {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/Views/Analytics/layouts/Header.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACJ;AACI;EACI,cAAA;AACR;AAAQ;EACI,cAAA;AAEZ;AADQ;EACI,gBAAA;AAGZ;AADI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAGR;AADQ;EACI,iBAAA;AAGZ;AADY;EACI,eAAA;AAGhB;AADY;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AAGhB;AADI;EACI,kBAAA;EACA,cAAA;EACA,eAAA;AAGR;AAFQ;EACI,aAAA;EACA,mBAAA;AAIZ;;AADA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AAGJ;AAFI;EACI,6BAAA;AAIR;AAHI;EACI,kBAAA;EACA,SAAA;AAKR;;AAHA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AAKJ;AAJI;EACI,6BAAA;AAMR;AALI;EACI,kBAAA;EACA,SAAA;AAOR;;AALA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,iCAAA;EACA,eAAA;AAQJ;AANI;EACI,wBAAA;EACA,qBAAA;AAQR;;AANA;EACI,kBAAA;AASJ;AAPI;EACI,iBAAA;AASR","sourcesContent":[".colaborador-infos\n    display: flex\n    margin: 0\n    margin-bottom: 40px\n    border-width: 1px 0\n    border-style: solid\n    border-color: #d9d9dc\n    list-style: none\n    align-items: center\n    justify-content: space-between\n    padding: 10px 15px\n\n    & .btnObtenerPDF\n        color: #7A6BE8\n        &:hover\n            color: #9b91ec\n        &:focus\n            box-shadow: none\n\n    & li\n        display: flex\n        gap: 1rem\n        align-items: center\n\n        &:nth-child(even)\n            font-weight: bold\n\n            &:nth-child(2)\n                font-size: 20px\n\n            & svg\n                fill: #fff\n                left: 2.3px\n                position: relative\n                transform: scale(.7)\n\n    .more-info\n        position: relative\n        color: #41C8FF\n        font-size: 14px\n        > button\n            display: flex\n            align-items: center\n\n\n.item-circle\n    display: flex\n    align-items: center\n    justify-content: center\n    border: none\n    text-align: center\n\n    width: 30px\n    height: 30px\n    border-radius: 50rem\n    background-color: #7A6BE8\n    border: 1px solid #7A6BE8\n    padding: 4px\n    transition: 300ms\n    &:where(:hover, :active)\n        background-color: transparent\n    & svg\n        position: relative\n        left: 4px\n\n.item-circle-white\n    display: flex\n    align-items: center\n    justify-content: center\n    border: none\n    text-align: center\n\n    width: 30px\n    height: 30px\n    border-radius: 50rem\n    background-color: #ffffff\n    border: 1px solid #ffffff\n    padding: 4px\n    transition: 300ms\n    &:where(:hover, :active)\n        background-color: transparent\n    & svg\n        position: relative\n        left: 4px\n\n.item-circle-down\n    width: 18px\n    height: 18px\n    display: flex\n    align-items: center\n    justify-content: center\n    border: none\n    transform: rotate(-90deg)\n    -ms-transform: rotate(-90deg)\n    -webkit-transform: rotate(-90deg)\n    cursor: pointer\n\n    & svg\n        fill: #41C8FF !important\n        transform: scale(.5)\n\n.item-menu\n    margin-right: 10px\n\n    &:nth-child(1)\n        font-weight: bold\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
